import { defaultFieldBlocks } from '../../../multiFieldPro/defaultFieldBlocks.js';
import { deepCopy } from '../../deepCopy.js';
import { toJSONString } from '../../toJSONString.js';
import { temporaryId } from '../../temporaryId.js';
import MultiFieldComponent from './components/MultiField.svelte';
import { mount } from "svelte";

/**
 * 柔軟に、かつ規則的にコンテンツを入力できるマルチフィールド
 * @deprecated
 * @requires jQuery, mtappVars
 * @param options
 */
export function multiField(options) {
    // バージョンチェック
    const version = typeof options.version !== 'undefined' ? Number(options.version) : 1;

    /**
     * フィールドの定義
     *
     * fieldBlocks: {
     *   uniqueFieldHandle: {
     *     type: 'fieldType', // フィールドのタイプ
     *     label: 'fieldLabel', // フィールドのラベル
     *     data: '', // 保存されるデータの受け皿
     *     url: '', // type が asset と image の場合のみ
     *     thumbnail: '', // type が image の場合のみ
     *     rows: '', // テキストエリアの初期行数（オプション）
     *     options: [], // 選択系フィールドの選択肢（オプション）
     *     },
     * }
     */
    options.fieldBlocks = options.fieldBlocks || {};
    const fieldBlocks = jQuery.extend({}, defaultFieldBlocks, options.fieldBlocks);

    options = jQuery.extend(
        {
            debug: false,
            addType: '',
            showAddContainer: false,
            showAddFieldButton: true,
            showViewRawDataButton: false,
            showSortButton: true,
            showInsertButton: true,
            showRemoveButton: true,
            addFieldButtonLabel: 'フィールドを追加',
            insertPoint: -1,
            insertPointDirection: 0,
            items: [],
            version: version,
            minBlocks: 0,
            maxBlocks: 0,
            maxBlocksType: '',
            maxBlocksMessage: {
                type: 'warning',
                title: 'お知らせ',
                content: '<p class="mb-0"><strong>最大ブロック数は %maxblocks です。</strong></p>'
            },
            updated: 0,
            /**
             * {
             *   type: 'fieldType', // フィールドのタイプ（一意）
             *   label: 'フィールドラベル', // フィールドのラベル
             *   yourFieldHandle: '初期値'
             * }
             */
            fieldGroups: [
                [
                    { type: 'h1', label: '見出し1', data: '' },
                    { type: 'h2', label: '見出し2', data: '' },
                    { type: 'h3', label: '見出し3', data: '' },
                    { type: 'h4', label: '見出し4', data: '' },
                    { type: 'h5', label: '見出し5', data: '' },
                    { type: 'h6', label: '見出し6', data: '' }
                ],
                [
                    { type: 'text', label: '1行テキスト', data: '' },
                    { type: 'email', label: 'Email', data: '' },
                    { type: 'url', label: 'URL', data: '' },
                    { type: 'tel', label: '電話番号', data: '' },
                    { type: 'password', label: 'パスワード', data: '' },
                    { type: 'number', label: '数値', data: '' },
                    { type: 'datepicker', label: '日付', data: '' },
                    { type: 'time', label: '時刻', data: '' },
                    { type: 'textarea', label: '複数行テキスト', rows: 8, data: '' },
                    { type: 'code', label: 'コードブロック', rows: 4, data: '' },
                    { type: 'tinymce', label: 'リッチテキスト', rows: 8, data: '' },
                    { type: 'asset', label: 'ファイル', url: '', data: '' },
                    { type: 'image', label: '画像', data: '', url: '', thumbnail: '', alt: '' }
                ],
                [
                    {
                        type: 'contentData',
                        label: 'コンテンツデータ',
                        siteId: 1,
                        contentTypeId: 1,
                        radio: false,
                        modalEdit: true,
                        modalCreate: true,
                        includeDraft: false,
                        dataLabelName: 'title',
                        data: ''
                    }
                ],
                [
                    {
                        type: 'select',
                        label: 'ドロップダウンリスト',
                        options: [
                            { label: 'リンゴ', data: 'apple' },
                            { label: 'オレンジ', data: 'orange' },
                            { label: 'キウィフルーツ', data: 'kiwi' }
                        ]
                    },
                    {
                        type: 'checkbox',
                        label: 'チェックボックス',
                        options: [
                            { label: 'リンゴ', data: 'apple', checked: false },
                            { label: 'オレンジ', data: 'orange', checked: false },
                            { label: 'キウィフルーツ', data: 'kiwi', checked: false }
                        ]
                    },
                    {
                        type: 'radio',
                        label: 'ラジオボタン',
                        options: [
                            { label: 'リンゴ', data: 'apple' },
                            { label: 'オレンジ', data: 'orange' },
                            { label: 'キウィフルーツ', data: 'kiwi' }
                        ]
                    },
                    {
                        type: 'table',
                        label: '表',
                        options: [
                            { type: 'text', label: '1行テキスト' },
                            { type: 'datepicker', label: '日付' },
                            { type: 'time', label: '時刻' },
                            { type: 'textarea', label: '複数行テキスト', rows: 1 },
                            { type: 'tinymce', label: 'リッチエディタ', rows: 8 },
                            { type: 'asset', label: 'ファイル', filename: '' },
                            { type: 'image', label: '画像', filename: '', thumbnail: '' },
                            {
                                type: 'select',
                                label: 'ドロップダウンリスト',
                                options: [
                                    { label: 'リンゴ', data: 'apple' },
                                    { label: 'オレンジ', data: 'orange' },
                                    { label: 'キウィフルーツ', data: 'kiwi' }
                                ]
                            },
                            {
                                type: 'checkbox',
                                label: 'チェックボックス',
                                options: [
                                    { label: 'リンゴ', data: 'apple' },
                                    { label: 'オレンジ', data: 'orange' },
                                    { label: 'キウィフルーツ', data: 'kiwi' }
                                ]
                            },
                            {
                                type: 'radio',
                                label: 'ラジオボタン',
                                options: [
                                    { label: 'リンゴ', data: 'apple' },
                                    { label: 'オレンジ', data: 'orange' },
                                    { label: 'キウィフルーツ', data: 'kiwi' }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'table-vertical-fixed',
                        label: '縦向き固定テーブル',
                        options: [
                            { type: 'text', label: '1行テキスト' },
                            { type: 'datepicker', label: '日付' },
                            { type: 'time', label: '時刻' },
                            { type: 'textarea', label: '複数行テキスト', rows: 1 },
                            { type: 'tinymce', label: 'リッチエディタ', rows: 8 },
                            { type: 'asset', label: 'ファイル' },
                            { type: 'image', label: '画像' },
                            {
                                type: 'select',
                                label: 'ドロップダウンリスト',
                                options: [
                                    { label: 'リンゴ', data: 'apple' },
                                    { label: 'オレンジ', data: 'orange' },
                                    { label: 'キウィフルーツ', data: 'kiwi' }
                                ]
                            },
                            {
                                type: 'checkbox',
                                label: 'チェックボックス',
                                options: [
                                    { label: 'リンゴ', data: 'apple' },
                                    { label: 'オレンジ', data: 'orange' },
                                    { label: 'キウィフルーツ', data: 'kiwi' }
                                ]
                            },
                            {
                                type: 'radio',
                                label: 'ラジオボタン',
                                data: 'orange',
                                options: [
                                    { label: 'リンゴ', data: 'apple' },
                                    { label: 'オレンジ', data: 'orange' },
                                    { label: 'キウィフルーツ', data: 'kiwi' }
                                ]
                            }
                        ]
                    }
                ],
                [
                    {
                        type: 'multi-column',
                        label: '2段組リッチテキスト',
                        options: [
                            { type: 'tinymce', col: 6 },
                            { type: 'tinymce', col: 6 }
                        ]
                    },
                    {
                        type: 'multi-column',
                        label: '3段組テキスト',
                        options: [
                            { type: 'textarea', rows: 8, col: 4 },
                            { type: 'textarea', rows: 8, col: 4 },
                            { type: 'textarea', rows: 8, col: 4 }
                        ]
                    },
                    {
                        type: 'multi-column-content',
                        label: '2段組コンテンツ',
                        options: [
                            [
                                { type: 'text', label: '小見出し' },
                                { type: 'tinymce', label: '本文' }
                            ],
                            [
                                { type: 'text', label: '小見出し' },
                                { type: 'tinymce', label: '本文' }
                            ]
                        ]
                    }
                ],
                [
                    {
                        type: 'textarea',
                        label: '定型文（セミナー案内）',
                        rows: 8,
                        data: '日時：\n\n会場：\n\n参加費：\n\n申し込み期限：'
                    }
                ]
            ]
        },
        options
    );

    const fieldId = options.id;
    let target = null;
    let savedData = '';
    let isRequired = false;
    let objectType = '';

    // 記事・ウェブページ・カテゴリ編集画面に対応
    if (mtappVars.screen_id === 'edit-entry' || mtappVars.screen_id === 'edit-page' || mtappVars.screen_id === 'edit-category') {
        target = document.getElementById(fieldId);
        if (!target) {
            return;
        }
        savedData = target.value;
        const $fieldBlock = jQuery('#' + fieldId + '-field');
        if ($fieldBlock.hasClass('required')) {
            isRequired = true;
        }
        $fieldBlock.after('<div id="mtapp-mf-' + fieldId + '"></div>').remove();
    }
    // コンテンツデータ
    else {
        if (
            typeof mtappVars.contentDataFields === 'undefined' ||
            typeof mtappVars.contentDataFields['contentField' + fieldId] === 'undefined'
        ) {
            return;
        }
        objectType = 'content_data';
        target = document.querySelector('[name="content-field-' + fieldId + '"]');
        if (target.required) {
            isRequired = true;
        }
        savedData = target.value;
        target.value = '{}';
        jQuery(mtappVars.contentDataFields['contentField' + fieldId])
            .find('#block_editor_data')
            .appendTo('#edit-content-type-data-form');
        jQuery(mtappVars.contentDataFields['contentField' + fieldId])
            .find('.modal-blockeditor')
            .appendTo('#edit-content-type-data-form');
        jQuery(mtappVars.contentDataFields['contentField' + fieldId])
            .after('<div id="mtapp-mf-' + fieldId + '"></div>')
            .hide()
            .find('textarea')
            .attr('name', '');
    }

    // 必須アイコンを付ける
    options.isRequired = isRequired;

    // 保存されているデータを変換
    if (savedData) {
        savedData = JSON.parse(savedData);
        // 描画されるのは savedData.items（コンポーネントへ data として渡る）。別配列へコピーして
        // しまうと以下の後方互換処理も仮IDの付与も効かなくなるので、必ずこの配列を直接書き換える。
        savedData.items.forEach(function (item) {
            // 後方互換
            if (['table-vertical'].indexOf(item.type) !== -1) {
                if (typeof item.data === 'undefined' || !item.data) {
                    item.data = JSON.parse(toJSONString(item.options));
                }
            }
            // multi-column の中の table-vertical のバグによるデータのマイグレーション
            if (!Object.prototype.hasOwnProperty.call(item, 'handle')) {
                return;
            }
            const fieldBlock = fieldBlocks[item.handle];
            if (fieldBlock.type === 'multi-column') {
                const allFieldsInMultiColumn = [];
                fieldBlock.columns.forEach(function (column) {
                    column.fields.forEach(function (fieldHandle) {
                        allFieldsInMultiColumn.push(fieldHandle);
                    });
                });
                fieldBlock.columns.forEach(function (column) {
                    column.fields.forEach(function (fieldHandle) {
                        if (fieldBlocks[fieldHandle].type.startsWith('table-vertical') && typeof item.data[fieldHandle] === 'undefined') {
                            item.data[fieldHandle] = {};
                            fieldBlocks[fieldHandle].fields.forEach(function (tableFieldHandle) {
                                item.data[fieldHandle][tableFieldHandle] = deepCopy(item.data[tableFieldHandle]);
                                if (!allFieldsInMultiColumn.includes(tableFieldHandle)) {
                                    delete item.data[tableFieldHandle];
                                }
                            });
                        }
                    });
                });
            }
        });
    } else {
        savedData = { items: [], version: version, ts: new Date().getTime() };
    }

    // 仮IDをセット。MultiField.svelte はブロックを item.id、MultiFieldTableVertical.svelte は
    // セルを cell.id でキーにしているため、ID の無い古いデータが2件以上あるとキーが重複して
    // フィールド全体が描画できなくなる。
    savedData.items.forEach(function (item) {
        if (typeof item.id === 'undefined') {
            item.id = temporaryId();
        }
        // 縦向きテーブルのセルは、上の後方互換処理で options から複製した直後や、Vue 版が ID を
        // 振らずに保存した場合に ID を持たない。
        if (typeof item.type === 'string' && item.type.startsWith('table-vertical') && Array.isArray(item.data)) {
            item.data.forEach(function (cell) {
                if (typeof cell.id === 'undefined') {
                    cell.id = temporaryId();
                }
            });
        }
    });

    // インスタンスを作成
    mtappVars.multiField = mtappVars.multiField || {};
    mtappVars.multiField['field' + fieldId] = {
        app: null,
        options: null
    };

    mtappVars.multiField['field' + fieldId].app = mount(MultiFieldComponent, {
            target: document.getElementById(`mtapp-mf-${fieldId}`),
            props: {
                mtappVars: mtappVars,
                data: savedData,
                isRequired: isRequired,
                objectType: objectType,
                options: options
            }
        });
}
